import React from 'react';
import { HStack, Stack } from '@chakra-ui/core';
import { SchemaBuilderProps } from './formBuilderSchema';
import FormElementTextBuilder from './FormElementTextBuilder';
import LabelSchemaBuilder from './LabelSchemaBuilder';
import InputPreview from './InputPreview';
import { useTranslation } from 'react-i18next';

export default function TimePickerSchemaBuilder(props: SchemaBuilderProps) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <LabelSchemaBuilder {...props} />
        {props?.labelRightRenderer}
      </HStack>
      <FormElementTextBuilder {...props} placeholder={t('formBuilder.editorPlaceholder.time')} />
      <InputPreview value={props?.defaultValue?.previewPlaceholders?.placeholder ?? 'HH:MM AM'} />
    </Stack>
  );
}
